import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { TagChipsInput } from "./TagChipsInput";
import { WeightRadioGroup } from "./WeightRadioGroup";
import type { DraftRuleAggregate } from "./types";

interface ScoringRuleEditorProps {
  aggregate: DraftRuleAggregate;
  suggestions: string[];
  onChange: (updated: DraftRuleAggregate) => void;
  onRemove: () => void;
}

export function ScoringRuleEditor({
  aggregate,
  suggestions,
  onChange,
  onRemove,
}: ScoringRuleEditorProps) {
  return (
    <div
      role="group"
      aria-label="Scoring-Regel"
      className="flex flex-wrap items-center gap-3 rounded-md border bg-background p-2"
    >
      <div className="min-w-[200px] flex-1">
        <TagChipsInput
          value={aggregate.tags}
          onChange={(tags) => onChange({ ...aggregate, tags })}
          suggestions={suggestions}
        />
      </div>

      <WeightRadioGroup
        value={aggregate.weight}
        onChange={(weight) => onChange({ ...aggregate, weight })}
        name={`weight-${aggregate.aggregateId}`}
      />

      <Input
        placeholder="Hinweis (optional)"
        aria-label="Hinweis zur Regel (optional)"
        value={aggregate.reasonText}
        onChange={(e) =>
          onChange({ ...aggregate, reasonText: e.target.value })
        }
        className="h-9 w-40 text-sm"
      />

      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-9 w-9 px-0 text-muted-foreground hover:text-destructive"
        onClick={onRemove}
        aria-label="Regel entfernen"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
